<button
    *ngIf="isUserProfitabilityEnabled"
    id="txtActualProfit"
    class="btn mr-2"
    [ngClass]="(profitMargin.profit > 0) ? 'btn-success' : 'btn-danger'"
    (click)="showProfitability()"
    matTooltip="{{'profitability_analysis' | translate}}" >
     {{  ( profitMargin.profit | currency: {decimal_places: 2} ) }}
     ({{ profitMargin.margin }}%)
  </button>